/*
 * BadgeType Messages
 *
 * This contains all the strings for the BadgeType component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Active citizen type name tooltip message
  typeAC: `Active`,
  // Ordinary citizen type name tooltip message
  typeGC: `Ordinary`,
  // Honorary citizen type name tooltip message
  typeHC: `Honorary`,
  // Meritorious citizen type name tooltip message
  typeMC: `Meritorious`,
  // Merchant citizen type name tooltip message
  typeMR: `Merchant`,
});
